"use client";

import { Text } from "@zapier/design-system";
import { TemplateCard } from "../TemplateCard";
import { EmptyState } from "src/components/TemplateGrid/EmptyState";
import styles from "./PublicTemplateGrid.module.css";
import { type Template } from "@zapier/templates";

interface PublicTemplateGridProps {
  templates: Template[];
  title: string;
}

export function PublicTemplateGrid({
  templates,
  title,
}: PublicTemplateGridProps) {
  const renderTemplates = () => {
    if (templates.length === 0) {
      return <EmptyState />;
    }

    return templates.map((template) => (
      <TemplateCard key={template.name} template={template} />
    ));
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        <Text type="PageHeader">{title}</Text>
      </div>
      <div className={styles.templatesWrapper}>{renderTemplates()}</div>
    </div>
  );
}
